import { PwaWorkspaceSettings } from './types';
import { WorkSpace1PwaSettings } from './Work-Space-1-Settings';
import { WorkSpace2PwaSettings } from './Work-Space-2-Settings';

export * from './types';
export { WorkSpace1PwaSettings, WorkSpace2PwaSettings };

export const PWA_WORKSPACE_REGISTRY: Record<string, PwaWorkspaceSettings> = {
  'workspace-1': WorkSpace1PwaSettings,
  'Work-Space-1-Settings': WorkSpace1PwaSettings,
  'workspace-2': WorkSpace2PwaSettings,
  'Work-Space-2-Settings': WorkSpace2PwaSettings,
};

export const getPwaWorkspaceByIdOrKey = (key?: string): PwaWorkspaceSettings => {
  const targetKey = key || 'workspace-1';
  if (PWA_WORKSPACE_REGISTRY[targetKey]) {
    return PWA_WORKSPACE_REGISTRY[targetKey];
  }
  const match = Object.values(PWA_WORKSPACE_REGISTRY).find(
    (ws) =>
      ws.workspaceId.toLowerCase() === targetKey.toLowerCase() ||
      ws.appSlug.toLowerCase() === targetKey.toLowerCase()
  );
  return match || WorkSpace1PwaSettings;
};
